// extracted by css-extract-rspack-plugin
export default {"menu":"menu-3A3fO","small":"small-1Jo0D","medium":"medium-4nezh","fullHeight":"fullHeight-3xElO"};